"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPricingTypeToString = transformPricingTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformPricingTypeToString(pricingType) {
    if (pricingType === legacy_enums_1.PricingType.SuperFlexible) {
        return "Super-flexible";
    }
    if (pricingType === legacy_enums_1.PricingType.Flexible) {
        return "Flexible";
    }
    return "Non-refundable";
}
//# sourceMappingURL=transformPricingTypeToString.js.map